import { graphql } from '@/generated/gql';

export const AUTOMATIC_ACCEPTANCE_TIMING_QUERY = graphql(/* GraphQL */ `
  query AutomaticAcceptanceTiming(
    $targetId: UUID!
    $variant: TsrctAutoAcceptTimingVariant!
    $isNegotiationCase: Boolean! = false
    $isSourcingCase: Boolean! = false
  ) {
    tesseract {
      automaticAcceptanceTiming(targetId: $targetId, variant: $variant) {
        targetId
        variant
        source
        plannedAt
        timing {
          reactionMinMinutes
          reactionMaxMinutes
          workingDays
          workingHours {
            start
            end
          }
          timezone
          holiday {
            country
            state
          }
        }
      }
      negotiationCase(id: $targetId) @include(if: $isNegotiationCase) {
        id
        status
      }
      sourcingCase(id: $targetId) @include(if: $isSourcingCase) {
        id
        status
      }
    }
  }
`);
